const USER_INFO = "step_user_info";
const storage = window.localStorage;
let userInfo = null;
let authList;
export default {
  login(obj) {
    storage.setItem(USER_INFO, JSON.stringify(obj));
    userInfo = obj;
  },
  logout() {
    userInfo = null;
    storage.clear();
  },
  isLogin() {
    return !!this.getToken();
  },
  getUserInfo() {
    if (!userInfo) {
      if (storage.getItem(USER_INFO) !== "undefined") {
        userInfo = JSON.parse(storage.getItem(USER_INFO));
      }
    }
    return userInfo || {};
  },
  getToken() {
    return this.getUserInfo().token;
  },
  getUserId() {
    return this.getUserInfo().userId;
  },
  getUserName() {
    return this.getUserInfo().userName;
  },
  getName() {
    return this.getUserInfo().name;
  },
  getAuth() {
    return this.getUserInfo().navItemList;
  },
  getAuthString() {
    return this.getUserInfo().userAuthority;
  },
  hasAuth(functionID) {
    try {
      authList = this.getUserInfo().navItemList;
      for (let item of authList) {
        if (item.functionID === functionID) {
          return true;
        }
      }
    } catch (e) {
      console.error(e);
      return false;
    }
  },
  getUserType() {
    return this.getUserInfo().userType;
  },
  getLoginType() {
    return this.getUserInfo().loginType;
  },
  getWorkshopNo() {
    return this.getUserInfo().workshopNo;
  },
};
